export const site = {
  name: 'Count Club',
  tagline: 'Austin',
  presentedBy: 'For ecommerce CFOs, by ecommerce CFOs',
  date: 'October 12–13, 2026',
  location: 'East Austin, TX',
  price: '$650',
  seats: 30,
  googleAnalyticsId: 'G-42VD0PZNY1',
  stripe: {
    buyButtonId: 'buy_btn_1U2s2JDJqnDYHMQe0lSPKWYV',
    publishableKey: 'pk_live_51U29zWDJqnDYHMQeboT1WP8cAae0d4TNbMTShKCMZzC0AFO8E8TnOTtIg8YvABkwwsKfpXtwZlHQdVWNqYyaYU0M00eb1Pt97X'
  },
  logoBeigeUrl: 'https://cdn.magicpatterns.com/uploads/mSrg22zjE5xCMS7zzmpfc1/Count_Club_Logo_beige.png',
  logoGreenUrl: 'https://cdn.magicpatterns.com/uploads/wEcPdHRMg9qDjiLRoGqLPy/Count_Club_Logo.webp',
  heroBgUrl: 'https://cdn.magicpatterns.com/patterns/generated-images/462929c4-f3d1-4b97-b043-eedc91104a1c.jpg',
  aboutImageUrl: 'https://cdn.magicpatterns.com/uploads/mT8o2NrQwJRYrucqvULV3f/Group_40183.webp',
  venueImageUrl: 'https://cdn.magicpatterns.com/patterns/generated-images/7c43ee9f-0a13-4379-aaf5-70c9a52948e9.jpg',
  video: {
    youtubeId: 'owobga9YRts',
    posterUrl: 'https://img.youtube.com/vi/owobga9YRts/maxresdefault.jpg',
    label: 'Watch the video',
    caption: 'A look inside the event'
  }
};
export const navLinks = [{
  label: 'About',
  href: '#about'
}, {
  label: 'Agenda',
  href: '#agenda'
}, {
  label: 'Register',
  href: '#register'
}];
export const partners = [{
  name: 'Ecom CFO',
  href: 'https://ecomcfo.co/'
}, {
  name: 'Ecom CPA',
  href: 'https://ecomcpa.com/'
}, {
  name: 'A2X',
  href: 'https://www.a2xaccounting.com/'
}, {
  name: 'Highbeam',
  href: 'https://www.highbeam.com/'
}, {
  name: 'Numeral',
  href: 'https://www.numeral.com/'
}];
export const aboutHighlights = [{
  title: 'The room',
  body: '30 finance leaders from 8 and 9 figure brands. You’ll leave knowing every name.'
}, {
  title: 'The sessions',
  body: 'Closed-door roundtables on the problems you’re actually facing: capital, forecasting, tariffs, tooling, org design, the founder relationship. Peer-led, no slides or recordings.'
}, {
  title: 'The food',
  body: 'Day 1 closes at Franklin Barbecue: private dinner, pit tour, no line.'
}];
export const reasons = [{
  title: 'Network with Leaders',
  body: 'Connect with 30 ecommerce finance leaders and CFOs facing similar growth challenges.'
}, {
  title: 'Hands-on Tools',
  body: 'Deep dive into the latest financial tech stacks with practical demos and workshops.'
}, {
  title: 'Franklin BBQ Dinner',
  body: 'Private restaurant takeover. No line required for the world-famous brisket.'
}, {
  title: 'Fireside Chat',
  body: 'Potential discussion with Aaron & Stacy Franklin on scaling a legendary business.'
}];
export type AgendaItem = {
  time: string;
  title: string;
  body: string;
};
export type AgendaDay = {
  id: string;
  date: string;
  label: string;
  items: AgendaItem[];
};
export const agenda: AgendaDay[] = [{
  id: 'day-1',
  date: 'October 12',
  label: 'Day 1 — Workshops & BBQ',
  items: [{
    time: '9:00 AM – 10:00 AM',
    title: 'Breakfast & Networking',
    body: 'Kick off the event with coffee, tacos, and introductions.'
  }, {
    time: '10:00 AM – 10:45 AM',
    title: "Who's in the Room",
    body: 'Interactive session to meet fellow attendees and discover shared challenges.'
  }, {
    time: '10:45 AM – 12:00 PM',
    title: 'AI for Commerce CFOs',
    body: 'Best use cases for AI in finance — featuring Claude for Excel and practical tools.'
  }, {
    time: '12:00 PM – 1:00 PM',
    title: 'Lunch Break',
    body: 'Catered lunch and open networking.'
  }, {
    time: '1:00 PM – 2:30 PM',
    title: 'Tech Stack Roundtables (Part 1)',
    body: '2 rotating tables × 10 people × 45 min each. Share what\u2019s working in your stack.'
  }, {
    time: '2:30 PM – 4:00 PM',
    title: 'Tech Stack Roundtables (Part 2)',
    body: '2 more rotating tables to round out the full circuit.'
  }, {
    time: '4:00 PM – 5:30 PM',
    title: 'Financial Reporting Tools & Approach',
    body: 'Reporting frameworks, dashboards, and the KPIs top-performing CFOs track.'
  }, {
    time: '6:30 PM – Late',
    title: 'Franklin Barbecue Private Dinner',
    body: 'Private takeover, full menu, local craft beer, and a fireside chat.'
  }]
}, {
  id: 'day-2',
  date: 'October 13',
  label: 'Day 2 — Strategy & Sessions',
  items: [{
    time: '9:00 AM – 10:30 AM',
    title: 'Scaling Past $25M and $50M',
    body: 'Operators who have crossed the line share what broke and what held.'
  }, {
    time: '10:30 AM – 12:00 PM',
    title: 'Capital & Cash Flow Clinic',
    body: 'Live teardowns of inventory financing, credit lines, and working capital models.'
  }, {
    time: '12:00 PM – 1:30 PM',
    title: 'Lunch & Open Tables',
    body: 'Self-selected tables by topic — margins, M&A, hiring, systems.'
  }, {
    time: '1:30 PM – 3:00 PM',
    title: 'The 2027 Finance Org',
    body: 'How lean commerce finance teams are structured, staffed, and automated.'
  }, {
    time: '3:00 PM – 5:00 PM',
    title: 'Closing Roundtable',
    body: 'Commitments, intros, and takeaways from the full room.'
  }]
}];
export const venueBullets = ['Private restaurant takeover — no line required', 'Full menu of brisket, ribs, and sides', 'Local craft beers and drinks included', 'Potential fireside chat with Aaron & Stacy Franklin'];
export const included = ['Two days of workshops & sessions', 'Breakfast, lunch & snacks', 'Private dinner at Franklin BBQ', 'Networking with 30 CFOs'];